import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild } from '@angular/router';
import { BaseParamsService } from '../base-params.service';

@Injectable()
export class BaseParamsResolverGuard implements CanActivate, CanActivateChild {
  private baseParamsService = inject(BaseParamsService);


  public canActivate(route: ActivatedRouteSnapshot): boolean {
    this.baseParamsService.parseParams(route);

    return true;
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot): boolean {
    return this.canActivate(childRoute);
  }
}
